// Кодирование данных в Base64
export function encodeURL(data: any): string {
    const jsonString = JSON.stringify(data);
    const encodedString = encodeURIComponent(jsonString);
    const base64String = btoa(encodedString);
    return base64String;
}

// Декодирование данных из Base64
export function decodeURL(encodeData: any): any {
    const encodedString = atob(encodeData);
    
    const jsonString = decodeURIComponent(encodedString);
    const obj = JSON.parse(jsonString);
   
    return obj;
}
    
    export const URL_TEMPLATE = {
        templateGet: 'http://app.expresstest.ru/order/cart?',
    }